import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function RequireAdmin({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="admin-loading">
        <Loader2 className="animate-spin text-league-blue" size={32} />
      </div>
    );
  }
  if (user === false) return <Navigate to="/admin/login" replace />;
  return children;
}
